import type { ApplicationStatus } from "../lib/types";

// Color map intentionally minimal — uses one of three semantic
// brackets (in-progress / terminal-good / terminal-bad) plus neutral
// for the rest. Keeps the table easy to scan without inventing nine
// distinct colors.
const COLOR: Record<ApplicationStatus, string> = {
  CREATED: "bg-brand-border text-brand-muted",
  // Send-form intake states use the amber bracket — they indicate
  // waiting-on-recipient. Distinct from the CardConnect-driven blue
  // states (submitted / signature_sent / in_review).
  LINK_SENT: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  LINK_OPENED: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  FORM_IN_PROGRESS: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  REVOKED: "bg-danger/10 text-danger-soft border-danger/30",
  READY_FOR_REVIEW: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  MNSP_SIGNED: "bg-brand-blue/15 text-brand-blue-bright border-brand-blue/40",
  SUBMITTED: "bg-brand-blue/15 text-brand-blue-bright border-brand-blue/40",
  SIGNATURE_SENT: "bg-brand-blue/15 text-brand-blue-bright border-brand-blue/40",
  IN_REVIEW: "bg-brand-blue/15 text-brand-blue-bright border-brand-blue/40",
  NEEDS_INFO: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  APPROVED: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  BOARDED: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  REJECTED: "bg-danger/10 text-danger-soft border-danger/30",
  ERROR: "bg-danger/10 text-danger-soft border-danger/30",
  ABANDONED: "bg-brand-border text-brand-muted",
  ARCHIVED: "bg-brand-border text-brand-muted",
};

const LABEL: Record<ApplicationStatus, string> = {
  CREATED: "Created",
  LINK_SENT: "Link sent",
  LINK_OPENED: "Link opened",
  FORM_IN_PROGRESS: "In progress",
  READY_FOR_REVIEW: "Ready for review",
  MNSP_SIGNED: "MNSP Signed",
  REVOKED: "Revoked",
  SUBMITTED: "Submitted",
  SIGNATURE_SENT: "Awaiting signature",
  IN_REVIEW: "In review",
  NEEDS_INFO: "Needs info",
  APPROVED: "Approved",
  BOARDED: "Boarded",
  REJECTED: "Rejected",
  ERROR: "Error",
  ABANDONED: "Abandoned",
  ARCHIVED: "Archived",
};

export function StatusBadge({ status }: { status: ApplicationStatus }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${COLOR[status]}`}
    >
      {LABEL[status]}
    </span>
  );
}
